<img [class]="className" [src]="url" (error)="onImgError($event)" />
